import { isDate, isEmpty } from 'lodash';
import { getLocale } from '@i18n';
import moment from 'moment';

// README: Some locale defaults to FR as it is what was required functionally

//Constant in seconds
const MINUTE = 60;
const HOUR = 3600;
const DAY = 86400;
const WEEK = 604800;
const MONTH = 2635200; //30.5 days
const YEAR = 31536000; //365 days

/**
 * Format to YYYY-M-D HH:MM:SS with the default locale
 * @param {*} date Date as ISO 8601 or MySQL Date, or Date object
 * @param {*} [locale=fr]
 */
export const dateToLocaleString = function (date, locale = 'fr') {
  if (!isDate(date)) {
    if (isEmpty(date)) {
      return '';
    }
    date = new Date(date);
  }
  return `${date.toLocaleDateString(locale)} ${date.toLocaleTimeString(locale)}`;
};

/**
 * Format to 2019-6-13 with the default locale
 * @param {*} date Date as ISO 8601 or MySQL Date, or Date object
 * @param {*} [locale=fr]
 */

export const dateToShortLocaleDateString = function (date, locale = 'fr') {
  if (!isDate(date)) {
    if (isEmpty(date)) {
      return '';
    }
    date = new Date(date);
  }
  return date.toLocaleDateString(locale);
};

export const dateToISOString = function (date) {
  if (!date.valueOf()) {
    return '';
  }
  return moment(date).format();
};

export const dateToDayMonthYearString = function (date) {
  if (!isDate(date)) {
    if (isEmpty(date)) {
      return '';
    }
    date = new Date(date);
  }
  return `${`0${date.getDate()}`.slice(-2)}/${`0${date.getMonth() + 1}`.slice(-2)}/${date.getFullYear()}`;
};

export const dateToHourMin = function (date) {
  if (!date.valueOf()) {
    return '';
  }
  return moment(date).format('HH:mm');
};

export const dateFormatterMixin = {
  methods: {
    dateToLocaleString,
    dateToShortLocaleDateString,
  },
};

export const dateRelativeToNow = function (date, locale = getLocale(), options = { style: 'long' }) {
  if (!isDate(date)) {
    if (isEmpty(date)) {
      return '';
    }
    date = new Date(date);
  }

  const diffSeconds = (date.getTime() - Date.now()) / 1000;
  let unit = 'minute';
  let converted = diffSeconds / MINUTE;
  if (Math.abs(diffSeconds) > YEAR) {
    unit = 'year';
    converted = diffSeconds / YEAR;
  } else if (Math.abs(diffSeconds) > MONTH) {
    unit = 'month';
    converted = diffSeconds / MONTH;
  } else if (Math.abs(diffSeconds) > WEEK) {
    unit = 'week';
    converted = diffSeconds / WEEK;
  } else if (Math.abs(diffSeconds) > DAY) {
    unit = 'day';
    converted = diffSeconds / DAY;
  } else if (Math.abs(diffSeconds) > HOUR) {
    unit = 'hour';
    converted = diffSeconds / HOUR;
  }

  const rtf = new Intl.RelativeTimeFormat(locale, options);
  return rtf.format(Math.trunc(converted), unit);
};
